import {axios} from "@/api/config";
// 查询危险源管理列表
export function listDeviceManager(params) {
  return axios.get(`/deviceManager/list`, params, true);
}

// 查询危险源管理详细
export function getDeviceManager(id) {
  return axios.get(`/deviceManager/${id}`, id, true)
}

// 新增危险源管理
export function addDeviceManager(params) {
  return axios.post('/deviceManager/addDeviceManager', params, false);
}

// 修改危险源管理
export function updateDeviceManager(params) {
  return axios.post('/deviceManager/editDeviceManager', params, false);
}


// 删除危险源管理
export function delDeviceManager(id) {
  return axios.delete(`/deviceManager/${id}`, true)
}

